import PptxGenJS from "pptxgenjs";
import { base64ToImage } from './VerbatimUtils';

export const handleGeneratePpt = (notes, slides) => {
  const pptx = new PptxGenJS();
  const slideWidth = 10;
  const slideHeight = 5.63;

  slides.forEach((slide) => {
    const slideNotes = notes.filter((note) => note.slideId === slide.id);
    const pptSlide = pptx.addSlide();

    // Title of the slide
    pptSlide.addText(slide.title, {
      x: 0.5,
      y: 0,
      fontSize: 18,
      bold: true,
      w: "90%",
      h: "10%",
      color: "000000",
      align: "center",
    });

    // Calculate maximum x and y positions
    let maxX = 0;
    let maxY = 0;
    slideNotes.forEach((note) => {
      maxX = Math.max(maxX, note.position.x);
      maxY = Math.max(maxY, note.position.y);
    });
    // Calculate compression ratio
    const compressionRatioX = slideWidth / (maxX / 100 + 1);
    const compressionRatioY = (slideHeight - 1) / (maxY / 100 + 1);
    const compressionRatio = Math.min(compressionRatioX, compressionRatioY);

    // Add notes (verbatims)
    slideNotes.forEach((note) => {
      const fontSize = 6;
      const marginTop = 1;

      // Position
      const posX = (note.position.x / 100) * compressionRatio;
      const posY = (note.position.y / 100 + marginTop) * compressionRatio;

      // Case 1 : simple text (string)
      if (typeof note.content === 'string') {
        const textHeight = (Math.ceil(note.content.length / 30) * fontSize * 1.2) / 72;

        pptSlide.addText(note.content, {
          x: posX,
          y: posY,
          fontSize: fontSize * compressionRatio,
          color: "000000",
          w: 3 * compressionRatio,
          h: textHeight * compressionRatio,
        });

      // Casse 2 : array of objects [{type: 'text'|'image', content: '...'}]
      } else if (Array.isArray(note.content)) {
        let currentY = posY;

        note.content.forEach((element) => {
          if (element.type === 'text' && element.content) {
            const text = element.content || '';
            const textHeight = (Math.ceil(text.length / 30) * fontSize * 1.2) / 72;

            pptSlide.addText(text, {
              x: posX,
              y: currentY,
              fontSize: fontSize * compressionRatio,
              color: "000000",
              w: 3 * compressionRatio,
              h: textHeight * compressionRatio,
            });

            currentY += textHeight * compressionRatio + 0.1;
          }

          if (element.type === 'image' && element.content) {
            const base64Image = base64ToImage(element.content);

            pptSlide.addImage({
              data: base64Image,
              x: posX, 
              y: currentY,
              w: 2.5 * compressionRatio,
              h: 2.5 * compressionRatio,
            });

            currentY += 2.6 * compressionRatio;
          }
        });
      }
    });
  });

  // Save the slides
  pptx.writeFile({ fileName: "slides.pptx" });
};



